import type { TDesktop } from '../../models/desktop';
import { MEDIA_SIZES } from '../../config';

export function imageSources(props: TDesktop) {
    const { background: { images = {} } = { images: {} } } = props;
    const { imgDesktop, imgDesktop4K, imgDesktopHD } = images;

    return [
        {
            media: MEDIA_SIZES.desktop,
            src: imgDesktop || imgDesktopHD || imgDesktop4K,
        },
        {
            media: MEDIA_SIZES.desktopHD,
            src: imgDesktopHD || imgDesktop4K || imgDesktop,
        },
        {
            media: MEDIA_SIZES.desktop4K,
            src: imgDesktop4K || imgDesktopHD || imgDesktop,
        },
    ];
}
